import { StyleSheet } from 'react-native'
import { corporateColor, transparentColor, white } from '../../theme/colors'
import { DOBRA, DOBRA_BOLD } from '../../theme/fonts'

export const styles = StyleSheet.create({
  centeredView: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: 0,
    backgroundColor: transparentColor,
  },

  containerContentModal: {
    backgroundColor: white,
    borderRadius: 20,
    padding: 42,
    paddingTop: 20,
    paddingLeft: 15,
    paddingRight: 15,
    paddingBottom: 35,
    justifyContent: 'center',
  },

  modalView: {
    margin: 20,
    backgroundColor: 'white',
    borderRadius: 20,
    padding: 35,
    alignItems: 'center',
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 4,
    elevation: 5,
  },
  button: {
    borderRadius: 20,
    padding: 10,
    elevation: 2,
  },
  buttonOpen: {
    backgroundColor: '#F194FF',
  },
  buttonClose: {
    backgroundColor: '#2196F3',
  },
  textStyle: {
    color: 'white',
    fontWeight: 'bold',
    textAlign: 'center',
  },
  modalText: {
    marginBottom: 15,
    textAlign: 'center',
  },

  title: {
    fontFamily: DOBRA,
    fontSize: 22,
    textAlign: 'center',
    color: '#212E39',
    paddingTop: 16,
    marginBottom: 8,
  },
  defaultTitle: {
    fontFamily: DOBRA_BOLD,
    color: corporateColor,
    fontSize: 22,
    textAlign: 'center',
  },

  textBody: {
    color: corporateColor,
    fontSize: 17,
    textAlign: 'center',
  },
})
